import * as tslib_1 from "tslib";
import styled from 'styled-components';
import zIndex from 'sinoui-components/styles/zIndex';
var PopContentLayout = styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: ", ";\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: ", ";\n"])), function (props) { return props.zIndex || zIndex.popover; });
export default PopContentLayout;
var templateObject_1;
//# sourceMappingURL=PopContentLayout.js.map